import React from "react";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";

interface UnitUrgencyProps {
    available: number;
}

export const UnitUrgency = ({available}: UnitUrgencyProps) => {

    const options = useDisplayOptionContext();

    return (
            options.vacancyNotice && available <= options.vacancyThreshold && available > 0 ? (
                <span className="unit-item-urgency tw:font-bold">Hurry, only {available} left!</span>
            ) : null
    )
}